import { gql } from "@apollo/client";

export const listProducts = gql`
  query ListProducts($filters: KeywordGroupFilter) {
    listKeywordGroups(type: "PRODUCT", filters: $filters) {
      id
      name
      type
      slug
      imageUrl
      keywords
      keywordsGroupIds
      deleted
      metadata
      category
    }
  }
`;
